import { Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SonaUsageFacade } from '@sona/angular-auth-domain';
import { SonaPurchaseStarterAuditsDialog } from '@sona/angular-payments/purchase-starter-audits-page';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { useDialog } from '@spartan-ng/ui-dialog-helm';
import { HlmSkeletonComponent } from '@spartan-ng/ui-skeleton-helm';
import { HlmTooltipImports } from '@spartan-ng/ui-tooltip-helm';

@Component({
    selector: 'sona-starter-audit-balance',
    imports: [
        HlmButtonDirective,
        TranslatePipe,
        HlmSkeletonComponent,
        HlmTooltipImports
    ],
    host: {
        class: 'tw-flex tw-gap-2 tw-items-center'
    },
    template: `
        @defer (when !usageFacade.isLoading()) {
            <button
                hlmBtn
                class="tw-flex-col tw-items-start tw-justify-end tw-gap-0.5 tw-px-2 tw-min-w-40"
                variant="ghost"
                [hlmTooltipTrigger]="'PAYMENTS.COMPONENT.STARTER_AUDITS_BALANCE.BUY_MORE' | translate"
                [attr.aria-description]="'PAYMENTS.COMPONENT.STARTER_AUDITS_BALANCE.BUY_MORE' | translate"
                (click)="openDialog()"
            >
                <div>
                    <span class="tw-font-medium">
                        {{ starterAudits() }}
                    </span>
                    {{'PAYMENTS.COMPONENT.STARTER_AUDITS_BALANCE.TITLE'| translate }}
                </div>
                <div class="tw-flex tw-gap-1 tw-w-full">
                    @if (
                        !displayedAuditsArray() ||
                        displayedAuditsArray().length === 0
                    ) {
                        <div
                            class="tw-h-2 tw-rounded-sm tw-bg-blue-200 tw-flex-1"
                        ></div>
                    } @else {
                        @for (i of displayedAuditsArray(); track i) {
                            <div
                                class="tw-h-2 tw-rounded-sm tw-bg-blue-500 tw-flex-1"
                            ></div>
                        }
                    }
                </div>
            </button>
        } @placeholder {
            <hlm-skeleton class="tw-h-8 tw-w-48" />
        }
    `
})
export class StarterAuditBalanceComponent {
    protected readonly usageFacade = inject(SonaUsageFacade);
    private readonly _dialog = useDialog();

    protected readonly starterAudits = computed(() => {
        const usage = this.usageFacade.usage();
        return usage?.starterAudits ?? 0;
    });

    protected readonly displayedAuditsArray = computed(() => {
        const count = this.starterAudits();
        
        if (count <= 10) {
            return count > 0 ? Array.from({ length: count }, (_, i) => i + 1) : [];
        } else {
            // For more than 10, show only 10 with the last one indicating "+X"
            const visibleCount = 9;
            const remaining = count - visibleCount;
            return [
                ...Array.from({ length: visibleCount }, (_, i) => i + 1),
                `+${remaining}`
            ];
        }
    });

    openDialog() {
        this._dialog.open(SonaPurchaseStarterAuditsDialog, {});
    }
}
